// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__muNe5","signatureButtonsRight":"ModalSign_signatureButtonsRight__2WofO"};